import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { IChatAuthResponse } from './interfaces';
import { ISupabaseAuthResponse } from '../ChatSupabase/interfaces';

class ChatApi {
    public createNickName(nickname: string): Promise<IChatAuthResponse> {
        return httpClientRepository.post(API_URLS.CHAT.SAVE_NICKNAME, {
            data: { nickname },
        });
    }

    public getAuth(): Promise<IChatAuthResponse> {
        return httpClientRepository.post(API_URLS.CHAT.AUTH);
    }

    public getSupabaseAuth(nickname: string, externalId: number): Promise<ISupabaseAuthResponse> {
        return httpClientRepository.post(API_URLS.CHAT.SUPABASE_AUTH, {
            data: { nickname, externalId },
            sameHost: true,
        });
    }
}

export const chatApi = new ChatApi();
